// UI
import ArtistListLoader from './ArtistListLoader'

export default ArtistListLoader